import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityTracker = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_451",
		"data-name": "Group 451",
		transform: "translate(-422.139 -223.412)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_450",
			"data-name": "Group 450",
			transform: "translate(422.139 223.412)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_2189",
				"data-name": "Path 2189",
				d: "M440.139,241.412h-18v-18h18Zm-17.724-.277h17.447V223.689H422.416Z",
				transform: "translate(-422.139 -223.412)",
				fill: "none"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2190",
			"data-name": "Path 2190",
			d: "M447.417,243.316c0-.022,0-.044-.007-.065a.761.761,0,0,0-.014-.076c-.005-.02-.011-.039-.018-.059a.679.679,0,0,0-.031-.075c-.009-.018-.018-.036-.029-.053a.723.723,0,0,0-.05-.071c-.011-.014-.022-.029-.035-.042a.711.711,0,0,0-.078-.07c-.01-.008-.017-.017-.026-.024l-.008,0c-.013-.009-.028-.016-.041-.024a.648.648,0,0,0-.07-.038.712.712,0,0,0-.085-.029l-.025-.008a.684.684,0,0,0-.169-.023h-3.885a.689.689,0,1,0,0,1.378h2.222l-4.1,4.1a1.116,1.116,0,0,1-1.541,0l-1.958-1.958a2.455,2.455,0,0,0-1.971-.713,2.592,2.592,0,0,0-1.584.778l-3.9,3.9a.689.689,0,0,0,.974.975l3.966-3.966a1.09,1.09,0,0,1,1.541,0l1.958,1.959a2.47,2.47,0,0,0,3.489,0l4.1-4.1v2.221a.689.689,0,1,0,1.378,0v-3.885C447.419,243.334,447.417,243.325,447.417,243.316Z",
			transform: "translate(-7.28 -14.768)",
			fill: "#101820"
		})]
	})]
});
const ForwardRef = forwardRef(SvgActivityTracker);
export { ForwardRef as ReactComponent };
